<template>
  <div class="embed-inner">
    <h2 v-if="heading">{{ heading }}</h2>
    <div v-if="summary" v-html="summary" class="block-split__intro" />
    <div class="embed-grant-charts">
      <div class="embed-grant-chart">
        <EmbedGrantChart0 />
      </div>
      <div class="embed-grant-chart">
        <EmbedGrantChart2 />
      </div>
    </div>
  </div>
</template>

<script>
import EmbedGrantChart0 from '@/components/Embed/EmbedGrantChart0';
import EmbedGrantChart2 from '@/components/Embed/EmbedGrantChart2';
export default {
  name: 'EmbedGrantCharts',
  components: {
    EmbedGrantChart0,
    EmbedGrantChart2
  },
  props: {
    heading: [String],
    summary: [Object]
  }
};
</script>

<style lang="postcss">
.embed-inner {
  @apply flex flex-col items-center;
}
.embed-grant-charts {
  width: 90%;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(30rem, 1fr));
  justify-content: center;
  align-items: center;
  gap: 40px;
  @apply pb-16;
  @screen lg {
    @apply pb-32;
  }
}
.embed-grant-chart {
  @apply z-30;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;

  section {
    max-width: 60rem;
    width: 100%;
  }
}
</style>
